import React, { useContext, useState } from 'react';
import * as S from './styled';
import Form from '../..';
import { ExportContext } from '../../../../provider/ExportProvider';

export default function FormDepositDelete() {
  const { setModal, setInvoice, getInvoice, deleteDeposits } =
    useContext(ExportContext)!.controllers.deposit;

  const [loading, setLoading] = useState(false);

  const selectedDeposit = getInvoice('selected.deposit');
  const selectedDeposits = getInvoice('selecteds.deposits');
  const depositIds =
    selectedDeposit !== -1 ? [selectedDeposit] : selectedDeposits;
  const length = depositIds.length;

  const close = () => {
    setModal('single.deleteDeposits', false);
    setInvoice('selected.deposit', -1);
  };
  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    deleteDeposits(depositIds)
      .then(() => {
        close();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <S.Form
      style={{
        maxHeight: '30vh',
      }}
      onSubmit={onSubmit}
    >
      <S.Body>
        <div style={{ marginLeft: '20px' }}>
          {length === 1
            ? 'Tem certeza que deseja excluir o depósito?'
            : `Tem certeza que deseja excluir ${length} depósitos?`}
        </div>
      </S.Body>
      <S.Actions>
        <Form.Button type="button" onClick={close}>
          Fechar
        </Form.Button>
        <Form.Button loading={loading}>Excluir</Form.Button>
      </S.Actions>
    </S.Form>
  );
}
